export type IssueSeverity = 'error' | 'warning' | 'info';

export type IssueAreaType =
  | {
      area: 'quote';
    }
  | {
      area: 'quoteLine';
      quoteLineUuid: string;
    }
  | {
      area: 'quoteLineInsights';
      quoteLineUuid: string;
    }
  | {
      area: 'quotePrice';
      quoteLineUuid: string;
      quotePriceUuid: string;
    }
  | {
      area: 'snapOperation';
      quoteLineUuid: string;
      snapOperationUuid: string;
    }
  | {
      area: 'snapRequirement';
      quoteLineUuid: string;
      snapOperationUuid: string;
      snapRequirementUuid: string;
    };

export const issueTypes = [
  'invalid',
  'price-quantity-warning',
  'duplication',
  'no-last-win',
  'rejected',
  'not-found',
  'insight',
] as const;

export type IssueOptions = (typeof issueTypes)[number];

type IssueActionType =
  | {
      type: 'modify';
      elementId: string;
    }
  | {
      type: 'display';
    }
  | {
      type: 'unrecoverable';
    };

export type IssueType = IssueAreaType & {
  id: string;
  title?: string;
  description?: string;
  severity: IssueSeverity;

  type: IssueOptions;
  field?: string;
  action: IssueActionType;

  parentIssueId?: string;
  childIssueIds: string[];
  siblingIssueIds: string[];
};

export type IssueInsertType = IssueAreaType & {
  title?: string;
  description?: string;
  severity: IssueSeverity;

  type: IssueOptions;
  field?: string;
  action: IssueActionType;

  parentIssueId?: string;
  childIssueIds?: string[];
  siblingIssueIds?: string[];
};

export type IssueDeleteOptions = {
  deleteParent: boolean;
};

export type IssuesType = Record<string, IssueType>;
